import { render, staticRenderFns } from "./NavbarUserDropdown.vue?vue&type=template&id=4bbe8cf2&scoped=true"
import script from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavbarUserDropdown.vue?vue&type=style&index=0&id=4bbe8cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe8cf2",
  null
  
)

export default component.exports